import { CIMSColumn } from 'components/CIMSTable/CIMSColumn/types'
import { CIMSTags } from 'components/CIMSTags'
import { useGlobalState } from 'context/GlobalStateContext'
import { alphabeticalSort } from 'shared'
import { HelpMessage } from 'utils/constants'
import { useUsersTableContext } from '../../../../UsersTableContext'
import { RoleTags } from './components/RoleTags'
import { User } from '../../../../UsersTableContext/types'
const Help = HelpMessage.Administration.Users

export const useColumns = (): CIMSColumn<User>[] => {
  const {
    state: { projectGlobalId: projectId },
  } = useGlobalState()
  const { roles, userGroups } = useUsersTableContext()
  return [
    {
      title: 'Display Name',
      help: Help.DisplayName,
      width: 200,
      render: 'displayName',
      sort: { with: 'key', key: 'displayName', default: 'ascend' },
      filter: {
        type: 'search',
        with: 'callback',
        onFilter: (value, { displayName, id }) =>
          displayName?.toLowerCase().includes(value.toString().toLowerCase()) ||
          id.toLowerCase().includes(value.toString().toLowerCase()),
      },
    },
    {
      title: 'Email',
      help: Help.Email,
      width: 300,
      render: ({ mail }) => mail,
      sort: { with: 'key', key: 'mail' },
      filter: { type: 'search', with: 'key', key: 'mail' },
    },
    {
      title: 'User Groups',
      help: Help.UserGroups,
      width: 300,
      render: ({ userGroups }) => (
        <CIMSTags
          tags={userGroups
            ?.filter(({ projectToUserGroups }) =>
              projectToUserGroups.some(
                ({ projectId: groupProjectId }) => groupProjectId === projectId
              )
            )
            .map(({ name }) => ({ text: name }))}
        />
      ),
      filter: {
        with: 'callback',
        items: userGroups
          .map(({ id, name }) => ({ value: id, text: name }))
          .sort(alphabeticalSort('text')),
        onFilter: (value, { userGroups }) =>
          userGroups?.some(({ id }) => value === id),
      },
    },
    {
      title: 'Roles',
      help: Help.RolesColumn,
      width: 250,
      render: (user) => <RoleTags {...user} />,
      filter: {
        with: 'callback',
        items: () => {
          const allRoles = [...roles, { id: 'null', name: 'Project Admin' }]
          return allRoles
            .sort(alphabeticalSort('name'))
            .map(({ id, name }) => ({ value: id, text: name }))
        },
        onFilter: (value, { roles, admin }) =>
          roles.some(({ id }) => value === id) ||
          (value === 'null' && admin !== null),
      },
    },
  ]
}
